import Link from 'next/link'
import { FC } from 'react'

import { cn } from '@lib/cn' // your classname helper
import { PROJECT_NAME } from '@lib/constants'

const FundingPipsLogo = (
  <svg width='20' height='22' viewBox='0 0 22 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <circle cx='2.42869' cy='2.4762' r='1.90476' fill='currentColor' />
    <rect x='9.09546' y='16.7619' width='3.80952' height='6.66667' rx='1.90476' fill='currentColor' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6.83622 2.4762C6.83622 1.42423 7.68901 0.571442 8.74098 0.571442H14.4348C18.3237 0.571442 21.4763 3.72405 21.4763 7.61298C21.4763 11.5019 18.3237 14.6545 14.4348 14.6545H4.33345V21.5238C4.33345 22.5758 3.48066 23.4286 2.42869 23.4286C1.37672 23.4286 0.523926 22.5758 0.523926 21.5238V10.845H14.4348C16.2198 10.845 17.6668 9.39797 17.6668 7.61298C17.6668 5.82799 16.2198 4.38097 14.4348 4.38097H8.74098C7.68901 4.38097 6.83622 3.52817 6.83622 2.4762Z'
      fill='currentColor'
    />
  </svg>
)

const FundingTicksLogo = (
  <svg
    version='1.1'
    id='Layer_1'
    xmlns='http://www.w3.org/2000/svg'
    x='0px'
    y='0px'
    width='24'
    height='26.8'
    viewBox='0 0 180 180'
  >
    <path
      fill='currentColor'
      opacity='1.000000'
      stroke='none'
      d='
M30.194195,140.719604 
	C30.194321,120.963264 30.194321,101.673073 30.194321,82.032547 
	C31.284124,81.873764 32.201496,81.623741 33.119007,81.623230 
	C68.745697,81.603226 104.372459,81.567230 139.999039,81.630875 
	C149.878586,81.648521 155.968170,89.546173 152.929688,98.078148 
	C151.107590,103.194527 146.682404,106.121216 140.445404,106.127785 
	C113.808655,106.155861 87.171860,106.139572 60.535076,106.139465 
	C58.894398,106.139465 57.253719,106.139473 54.973812,106.139473 
	C54.973812,114.638268 54.973732,122.891609 54.973854,131.144958 
	C54.973900,134.474564 54.982719,137.804184 54.973064,141.133759 
	C54.947811,149.842270 50.038364,155.613022 42.655663,155.623459 
	C35.336918,155.633804 30.464981,149.989288 30.194195,140.719604 
z'
    />
    <path
      fill='currentColor'
      opacity='1.000000'
      stroke='none'
      d='
M81.340935,32.125797 
	C101.267754,32.125904 120.733002,32.061745 140.197540,32.153084 
	C149.723557,32.197781 155.753586,39.983997 153.018570,48.400635 
	C151.297028,53.698429 146.646057,56.916275 140.333084,56.930092 
	C120.701851,56.973053 101.070457,56.961525 81.439156,56.938320 
	C73.096153,56.928459 67.397316,52.045364 67.197083,44.835056 
	C66.999222,37.709980 72.454170,32.642765 81.340935,32.125797 
z'
    />
    <path
      fill='currentColor'
      opacity='1.000000'
      stroke='none'
      d='
M92.686417,116.212814 
	C101.369095,118.577835 104.174652,122.252739 104.203735,130.866409 
	C104.217735,135.013977 104.317940,139.165970 104.167641,143.308289 
	C103.916473,150.230484 98.450874,155.544159 91.699051,155.624176 
	C84.800003,155.705948 79.152863,150.217209 78.940010,143.067245 
	C78.816635,138.923218 78.901665,134.772491 78.918991,130.624878 
	C78.957077,121.507080 83.089806,117.048729 92.686417,116.212814 
z'
    />
    <path
      fill='currentColor'
      opacity='1.000000'
      stroke='none'
      d='
M54.976002,44.110542 
	C54.103313,51.656975 50.213184,56.081310 44.114166,56.883694 
	C38.672382,57.599613 33.023468,54.144264 31.047318,48.890911 
	C29.059023,43.605286 30.986200,37.571033 35.694275,34.340660 
	C43.499256,28.985390 52.815350,33.511379 54.976002,44.110542 
z'
    />
  </svg>
)

const TradinLogo = (
  <svg xmlns='http://www.w3.org/2000/svg' width='34' height='34' viewBox='0 0 512 512'>
    <g fill='none' fillRule='evenodd'>
      <path
        fill='#08083A'
        d='M48 0h416c26.509668 0 48 21.490332 48 48v416c0 26.509668-21.490332 48-48 48H48c-26.509668 0-48-21.490332-48-48V48C0 21.490332 21.490332 0 48 0Z'
      />
      <path
        fill='#FFF'
        fillRule='nonzero'
        d='M286 241.810889V443l-80-71.194577V165l80 76.810889ZM390 164H205.392667L122 82h268v82Z'
      />
    </g>
  </svg>
)

export const Logo: FC<{ className?: string }> = ({ className = 'mr-4' }) => {
  let logo
  switch (PROJECT_NAME) {
    case 'fundingticks':
      logo = FundingTicksLogo
      break
    case 'tradin':
      logo = TradinLogo
      break
    default:
      logo = FundingPipsLogo
      break
  }

  return (
    <Link href='/' className={cn('flex items-center', className)}>
      <div className='flex items-center justify-center min-h-10 min-w-10 bg-card rounded-lg shadow-md border border-border hover:border-muted-foreground transition-colors duration-200 hover:shadow-sm'>
        {logo}
      </div>
    </Link>
  )
}
